import Actions from "common/Actions/Actions";
import { Button } from "common/Button/Button";
import CommandmentStatus from "common/CommandmentStatus/CommandmentStatus";
import OrderStatus from "common/OrderStatus/OrderStatus";
import { P } from "common/P/P";
import Pagination from "components/Pagination/Pagination";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface CommandmentsTableProps {
	data: any;
	onRowClick: (order: any) => void;
}

const CommandmentsTable: React.FC<CommandmentsTableProps> = ({
	data,
	onRowClick,
}) => {
	const { t } = useTranslation();

	const handleCancelOrder = async (
		event: React.MouseEvent<HTMLButtonElement>,
		order: any
	) => {
		event.stopPropagation();
		// if (order.orderStatus === "Waiting") {
		// 	try {
		// 		const updatedOrder = await orderService.updateUserOrder(
		// 			order.userId,
		// 			order._id,
		// 			{ orderStatus: "Cancelled" }
		// 		);
		// 		window.location.reload();
		// 		// Update the state or re-fetch orders to reflect the changes
		// 	} catch (error) {
		// 		console.error("Error cancelling order:", error);
		// 	}
		// }
	};
	return (
		<>
			<table className="w-full border rounded-lg border-strokeColor">
				<thead className="bg-white border border-strokeColor">
					<tr className="bg-bgColor">
						<th className="px-5 py-[18px] text-left border-b border-strokeColor">
							<P size="p3" type="regular" className="text-mainColor">
								Ady
							</P>
						</th>
						<th className="px-5 py-[18px] text-left border-b border-strokeColor">
							<P size="p3" type="regular" className="text-mainColor">
								Senesi
							</P>
						</th>
						<th className="px-5 py-[18px] text-left border-b border-strokeColor">
							<P size="p3" type="regular" className="text-mainColor">
								Ýerine ýetirmeliler
							</P>
						</th>
						<th className="w-16 px-5 py-[18px] text-left border-b border-strokeColor">
							<P size="p3" type="regular" className="text-mainColor">
								Ýagdaýy
							</P>
						</th>
					</tr>
				</thead>
				<tbody className="text-left">
					{data.map((item: any, idx: any) => (
						<tr
							key={item._id + idx}
							className={`${
								idx === data.length - 1
									? "border-0"
									: "border-b border-strokeColor"
							} ${idx % 2 === 0 ? "bg-white" : "bg-[#f9f9f9]"}`}
							onClick={() => onRowClick(item)}
						>
							<td className="px-5 py-[18px]">
								<P size="p3" type="light">
									{item.commandName}
								</P>
							</td>
							<td className="px-5 py-[18px] font-medium text-textColor">
								<P size="p3" type="light">
									{new Date(item.date)
										.toLocaleDateString("en-GB", {
											day: "2-digit",
											month: "2-digit",
											year: "numeric",
										})
										.replace(/\//g, ".")}
								</P>
							</td>

							<td
								className={`px-5 py-[18px] text-textColor font-regular ${
									idx === data.length - 1 ? "rounded-br-lg" : ""
								}`}
							>
								<P size="p3" type="light">
									{item.currentUserId.name} {item.currentUserId.sirname}
								</P>
							</td>

							<td className="px-5 py-[18px]">
								<CommandmentStatus status={item.status} />
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</>
	);
};

export default CommandmentsTable;
